import { render, staticRenderFns } from "./society.vue?vue&type=template&id=668c39f0&scoped=true"
import script from "./society.vue?vue&type=script&lang=js"
export * from "./society.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "668c39f0",
  null
  
)

export default component.exports